import { NgModule } from "@angular/core";
import { SafeHtmlPipe } from "../../../pipe/safe-html.pipe";

@NgModule({
    imports: [],
    exports: [SafeHtmlPipe],
    declarations: [SafeHtmlPipe],
})
export class SafeHtmlPipeModule {}
